import BasicService from "./BasicService";

class Bank extends BasicService {
  constructor() {
    super();
  }

//   bank
  deleteBank(bank){
    let url = `/os/bankTypes/${bank.bankTypeId}`;
    return this.axios.delete(url,bank).then(request => request.data);
  }
  updateBank(bank){
    let url = `/os/bankTypes/${bank.bankTypeId}`;
    return this.axios.put(url,bank).then(request => request.data);
  }
  addBank(bank) {
    let url = `/os/bankTypes`;
    return this.axios.post(url,bank).then(request => request.data);
  }
  getBank() {
    let url = `/os/bankTypes`;
    return this.axios.get(url).then(request => request.data);
  }
}

const bankService = new Bank();
export default bankService;
